   <app-client *ngIf="user.type == 'customer'"></app-client>
   <app-architect *ngIf="user.type == 'designer'"></app-architect>
   <app-admin *ngIf="user.type == 'admin'"></app-admin>
